import { render, staticRenderFns } from "./Debate.vue?vue&type=template&id=e3585b4a&scoped=true&"
import script from "./Debate.vue?vue&type=script&lang=js&"
export * from "./Debate.vue?vue&type=script&lang=js&"
import style0 from "./Debate.vue?vue&type=style&index=0&id=e3585b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3585b4a",
  null
  
)

component.options.__file = "Debate.vue"
export default component.exports